// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__32Hrw","info":"PatientInfo_info__10ELa"};